var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sidebar-right",
    {
      class: [
        "navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--720",
        { open: _vm.show },
      ],
      on: { overlayClicked: _vm.outside },
    },
    [
      _c("div", { staticClass: "bg-white md__card--holder clearfix" }, [
        _c("div", [
          _c(
            "div",
            {
              staticClass: "card-header d-flex align-items-center",
              class: {
                "blue-class": _vm.$route.name == "projects",
                "green-class": _vm.$route.name == "tasks.home",
                "yellow-class": _vm.$route.name == "timesheet.home",
              },
            },
            [
              _c("h4", { staticClass: "h3 mb-0" }, [
                _c("span", { staticClass: "right-bracket" }, [_vm._v("{ ")]),
                _vm._v(" Invoice\n        "),
              ]),
            ]
          ),
          _c("div", { staticClass: "card-header" }, [
            _c("p", [
              _vm._v(
                "\n          Pricing is simple, $5 AUD per month\n        "
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "payment-block" }, [
          _c("div", { staticClass: "card-body text-center" }, [
            _c("h2", { staticClass: "text-success" }, [
              _vm._v("Invoice Form here"),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }